export default __webpack_public_path__ + "static/media/banner-home-1680x1050.1139807e.png";